import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import 'zone.js/dist/zone';
import {AppModule} from './app.module';
import {environment} from './environments/environment';

enableProdMode();

platformBrowserDynamic().bootstrapModule(AppModule, {
  preserveWhitespaces: true
});



